export default "__VITE_ASSET__qDVlhJiV__"